import {UI} from "../../../../stem-core/src/ui/UIBase";

import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {WalletCard, WalletCardStyle} from "../../ui/WalletCard";
import {Messages} from "../../../Messages";
import {WalletButton} from "../../ui/WalletButton";
import {LoadingWidget} from "../../ui/LoadingWidget";
import {WalletPopup} from "../../ui/WalletPopup";
import {WALLET_CARD_CONTENT_HEIGHT} from "../../WidgetConstants";
import {CardInput} from "./components/CardInput";
import {Dispatcher} from "../../../../stem-core/src/base/Dispatcher";
import {WidgetRoutes} from "../../WidgetRoutes";
import {apiSetPrimaryPaymentMethod} from "../../../../client/state/PaymentMethodStore";
import {Router} from "../../../../stem-core/src/ui/Router";


class ElementStyle extends WalletCardStyle {
    @styleRule
    addCardLabel = {
        fontSize: 20,
        fontWeight: "bold",
        marginBottom: 22,
    };

    @styleRuleInherit
    content = {
        height: WALLET_CARD_CONTENT_HEIGHT,
    };
}

@registerStyle(ElementStyle)
export class AddCardClass extends WalletCard {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.addNewPaymentMethod,
        };
    }

    render() {
        return <CardInput ref="cardInput" label={""}/>;
    }

    renderPrimaryButton() {
        return (
            <WalletButton disabled={!this.cardInput || !this.cardInput.isLoaded()} onClick={() => this.addCard()}>
                {Messages.saveNewCard}
            </WalletButton>
        );
    }

    async addCard() {
        // TODO: refactor this.
        // This is in an intermediary state. We should use async/await on confirmCard call
        const requestCardConfirmation = (onSuccess, onError) => {
            this.cardInput.confirmCard(
                async card => {
                    try {
                        await apiSetPrimaryPaymentMethod(card.id);
                        onSuccess();
                    } catch (error) {
                        onError(error);
                    }
                }, onError);
        };

        try {
            await LoadingWidget.walletLoad(async () => new Promise(requestCardConfirmation));
            this.handleCardSuccessfullyAdded();
        } catch (error) {
            // TODO: handle API errors
        }
    }

    handleCardSuccessfullyAdded() {
        Dispatcher.Global.dispatch("widgetCardAdded");
        if (Router.localHistory.slice(-1)[0].slice(1) === WidgetRoutes.INDEX_COLLAPSED) {
            return;
        }
        this.discard();
    }

    onMount() {
        super.onMount();
        this.cardInput.addListener("load", () => this.redraw());
    }
}

const ElementPopup = WalletPopup(AddCardClass);

export class AddCard extends ElementPopup {
    hide() {
        Dispatcher.Global.dispatch("widgetHideAddCard");
        return super.hide();
    }
}
